var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuCollapsedEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16H17.3333V13.3333H0V16ZM0 9.33333H13.3333V6.66667H0V9.33333ZM0 0V2.66667H17.3333V0H0ZM24 12.7867L19.2267 8L24 3.21333L22.12 1.33333L15.4533 8L22.12 14.6667L24 12.7867Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2267 8L24 12.7867L22.12 14.6667L15.4533 8L22.12 1.33333L24 3.21333L19.2267 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuCollapsedEnd);
export default __webpack_public_path__ + "static/media/IconMenuCollapsedEnd.713db6626c110598f5a17e04ab7813b1.svg";
export { ForwardRef as ReactComponent };